<template>
  <span class="note_icon" @click="$emit('click')">?</span>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.note_icon {
  display: inline-block;
  width: 26px;
  height: 26px;
  background-color: #B7E6F1;
  color: #ffffff;
  text-align: center;
  line-height: 26px;
  border-radius: 13px;
  cursor: pointer;
}
</style>
